import { useEffect, useMemo, useState } from "react";
import BookingStepCustomer from "@/components/BookingStepCustomer";
import BookingStepService from "@/components/BookingStepService";
import BookingStepVisit from "@/components/BookingStepVisit";
import { getService } from "@/data/services";
import { formatApiError, submitBooking } from "@/lib/api";

const emptyForm = {
  category: "",
  subcategory: "",
  problem_description: "",
  preferred_date: "",
  preferred_time: "",
  address: "",
  postal_code: "",
  city: "",
  contact_method: "Telefone",
  urgent: "false",
  name: "",
  phone: "",
  email: "",
  additional_notes: "",
  quote_before_service: "false",
};

export default function BookingWizard({ initialService = "" }) {
  const [form, setForm] = useState({ ...emptyForm, category: initialService });
  const [files, setFiles] = useState([]);
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const selectedService = useMemo(() => getService(form.category), [form.category]);

  useEffect(() => {
    if (initialService && getService(initialService)) setForm((current) => ({ ...current, category: initialService }));
  }, [initialService]);

  const next = () => {
    setError("");
    if (step === 1 && (!form.category || !form.subcategory || !form.problem_description.trim())) return setError("Escolha uma categoria, um serviço específico e explique o problema.");
    if (step === 2 && (!form.preferred_date || !form.preferred_time || !form.address || !form.postal_code || !form.city)) return setError("Indique a data, o período e a morada para podermos preparar a visita.");
    setStep((current) => Math.min(current + 1, 3));
  };

  const back = () => { setError(""); setStep((current) => Math.max(current - 1, 1)); };
  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await submitBooking(form, files);
      setStep(4);
    } catch (submissionError) {
      setError(formatApiError(submissionError));
    } finally {
      setSubmitting(false);
    }
  };

  if (step === 4) return <div className="booking-success" data-testid="booking-success-message"><span className="success-mark">✓</span><span className="eyebrow">Pedido recebido</span><h2>Obrigado. Já temos o seu pedido.</h2><p>Recebemos a informação. A equipa Problema360 entrará em contacto consigo para confirmar os detalhes e a disponibilidade da visita.</p><button type="button" className="button button-ghost" onClick={() => { setForm(emptyForm); setFiles([]); setStep(1); }} data-testid="booking-new-request-button">Fazer outro pedido</button></div>;

  return (
    <div className="booking-wizard" data-testid="booking-wizard">
      <div className="booking-progress" data-testid="booking-progress">
        {["Serviço", "Visita", "Contacto"].map((label, index) => <div key={label} className={`progress-item ${step >= index + 1 ? "active" : ""}`}><span>0{index + 1}</span><b>{label}</b></div>)}
      </div>
      {selectedService && <div className="selected-service-note">A pedir: <strong>{selectedService.name}</strong></div>}
      {step === 1 && <BookingStepService form={form} setForm={setForm} onNext={next} error={error} />}
      {step === 2 && <BookingStepVisit form={form} setForm={setForm} onNext={next} onBack={back} error={error} />}
      {step === 3 && <BookingStepCustomer form={form} setForm={setForm} files={files} setFiles={setFiles} onBack={back} onSubmit={submit} error={error} submitting={submitting} />}
    </div>
  );
}
